import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

import { Dropdown } from '@arco-design/web-react';
import { IconApps, IconDown, IconMindMapping, IconRight, IconTool } from '@arco-design/web-react/icon';

import { isPublicPlazaPath, publicPlazaPaths } from '@/pages/home/utils/publicPlazaPaths';

import styles from '../styles/index.module.less';

/** 门户资源广场入口，后续新增算力、镜像等广场时继续在此扩展。 */
export const EXPLORE_ITEMS = [
  {
    key: 'model',
    labelKey: 'home:market.model.repository',
    descriptionKey: 'home:market.model.repository.description',
    path: publicPlazaPaths.modelRepo,
    icon: <IconMindMapping />,
  },
  {
    key: 'application',
    labelKey: 'home:market.app.center',
    descriptionKey: 'home:market.app.center.description',
    path: publicPlazaPaths.appCenter,
    icon: <IconApps />,
  },
  {
    key: 'skill',
    labelKey: 'home:market.skill',
    descriptionKey: 'home:market.skill.description',
    path: publicPlazaPaths.skillCenter,
    icon: <IconTool />,
  },
] as const;

/** 顶部导航资源广场下拉入口。 */
export default function Explore() {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const active = isPublicPlazaPath(pathname);

  const openMarketplace = (path: string) => {
    navigate(path);
  };

  const dropList = (
    <div className={styles.exploreMenu}>
      {EXPLORE_ITEMS.map((item) => (
        <button key={item.key} type="button" className={styles.exploreMenuItem} onClick={() => openMarketplace(item.path)}>
          <span className={styles.exploreMenuIcon}>{item.icon}</span>
          <span className={styles.exploreMenuContent}>
            <strong>{t(item.labelKey)}</strong>
            <small>{t(item.descriptionKey)}</small>
          </span>
          <IconRight className={styles.exploreMenuArrow} />
        </button>
      ))}
    </div>
  );

  return (
    <Dropdown droplist={dropList} position="bl" getPopupContainer={(triggerNode) => triggerNode.closest('[data-top-nav]') || document.body}>
      <span className={`${styles['navbar-right-btn']} ${styles.exploreTrigger} ${active ? styles.exploreTriggerActive : ''}`}>
        {t('common:resource.marketplace')}
        <IconDown />
      </span>
    </Dropdown>
  );
}
